import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import QuestionEditor from '../QuestionEditor/QuestionEditor';
import styles from './SortableQuestionItem.module.css';
import {FiGrid} from 'react-icons/fi';

const SortableQuestionItem = ({question, questionNumber}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({id: question.id || question.temp_id});

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.2 : 1,
        zIndex: isDragging ? 100 : 'auto',
        marginBottom: '15px',
        position: 'relative',
    };

    return (
        <div ref={setNodeRef} style={style} className={styles.sortableItemWrapper}>
            {/*<div {...attributes} {...listeners} className={styles.dragHandleTopCenter} aria-label="Перетащить вопрос"></div>*/}
            <button
                {...attributes}
                {...listeners}
                className={styles.dragHandleButton}
                aria-label="Перетащить вопрос"
            >
                <div className={styles.dragHandleBar}></div>
            </button>
            {/* Передаем только данные, а не функции */}
            <QuestionEditor question={question} questionNumber={questionNumber}/>
        </div>
    );
};
export default SortableQuestionItem;
